import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

import useTapPay from '../hooks/useTapPay';
import { Context } from '../context/DataContext';

const TapPayPage = () => {
  const navigate = useNavigate();
  const { state, sendTapPayPrime } = React.useContext(Context);
  const {
    customerInfo: { orderId },
    app: { ApId: appId, ApKey: appKey, Env: env },
  } = state;
  const [TapPay] = useTapPay({
    appId,
    appKey,
    env,
  });
  const [isValidated, setIsValidated] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const [showBackBtn, setShowBackBtn] = React.useState(false);

  React.useEffect(() => {
    TapPay.cardSetup(
      '#tappay-iframe',
      {
        color: 'rgb(0,0,0)',
        fontSize: '15px',
        lineHeight: '24px',
        fontWeight: '300',
        errorColor: 'red',
        placeholderColor: '',
      },
      {
        isUsedCcv: true,
        // 此設定會顯示卡號輸入正確後，會顯示前六後四碼信用卡卡號
        isMaskCreditCardNumber: true,
        maskCreditCardNumberRange: {
          beginIndex: 6,
          endIndex: 11,
        },
      }
    );
    TapPay.onCardUpdate(({ canGetPrime }) => {
      setIsValidated(canGetPrime);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <Typography variant='h4' sx={{ my: 2 }}>
        信用卡分期付款
      </Typography>
      <Box>
        <Box sx={{ p: 2 }}>
          <Typography variant='h6' sx={{ my: 1, textAlign: 'left' }}>
            信用卡卡號
          </Typography>
          <Box
            id='tappay-iframe'
            sx={{
              margin: 0,
              outline: 0,
              tapHighlightColor: 'rgba(255,255,255,0)',
              lineHeight: '1.21428571em',
              padding: '.578571em 1em',
              fontSize: '1em',
              background: '#fff',
              border: '1px solid rgba(34,36,38,.15)',
              color: 'rgba(0,0,0,.87)',
              borderRadius: '.28571429rem',
              boxShadow: '0 0 0 0 transparent inset',
              transition: 'color .1s ease,border-color .1s ease',
              width: '100%',
              boxSizing: 'border-box',
            }}
          />
        </Box>
        <Typography variant='body1' sx={{ my: 2, textAlign: 'justify', px: 2 }}>
          本人同意於定期繳款截止日前，依上述交易進行自動扣款。且於下列卡號因補/換/續發新卡或升等其他事由而變更時，此授權對變更後之卡號亦適用之。
        </Typography>
        {errorMsg ? (
          <Box>
            <Typography variant='h6' sx={{ my: 2, color: 'red' }}>
              {errorMsg}
            </Typography>
            {showBackBtn ? (
              <Button
                color='warning'
                sx={{ width: 168, marginBottom: 2 }}
                onClick={() => {
                  navigate('/check-order-info-again');
                }}
              >
                重新選擇付款方式
              </Button>
            ) : null}
          </Box>
        ) : null}
        <Button
          variant='contained'
          sx={{ width: 168 }}
          disabled={!isValidated}
          onClick={() => {
            setErrorMsg('');
            setShowBackBtn(false);

            TapPay.getDirectPayPrime()
              .then(({ prime }) => {
                // success
                // send prime to api
                sendTapPayPrime(
                  { orderId, primeCode: prime },
                  ({ responseCode, rtnObj, responseMsg }) => {
                    if (responseCode === '000') {
                      navigate('/upload-photos');
                    } else if (responseCode === '002') {
                      navigate('/select-installment');
                    } else if (responseCode === '104') {
                      // show error msg and back button
                      setErrorMsg(responseMsg);
                      setShowBackBtn(true);
                    } else {
                      setErrorMsg(rtnObj);
                    }
                  }
                );
              })
              .catch((e) => {
                // error
                setErrorMsg(e);
              });
          }}
        >
          下一步
        </Button>
      </Box>
    </Box>
  );
};

export default TapPayPage;
